/* oxlint-disable */
import React from 'react';

import {
  Breadcrumb, BreadcrumbSeparator, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage,
} from '@/components/ui/breadcrumb';

import PoolPrize from './PoolPrize';

interface TimeLeft {
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
}

interface DesktopHeaderProps {
  cmsTournament: any;
  tournament: any;
  poolPrize: any;
  timeLeft: TimeLeft;
  status: string;
}

const formatUnits = (unit: string) => {
  switch (unit) {
    case 'days':
      return 'Días';
    case 'hours':
      return 'Horas';
    case 'minutes':
      return 'Minutos';
    case 'seconds':
      return 'Segundos';
    default:
      return '';
  }
};

const DesktopHeader = ({
  cmsTournament, tournament, poolPrize, timeLeft, status,
}: DesktopHeaderProps) => {
  return (
    <div>
      {' '}
      <div className="relative w-full rounded-xl overflow-hidden">
        <Breadcrumb className="my-5 mt-9 px-8 py-4">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink
                href="/"
                className="hover:text-sivarbet-primary"
              >
                Inicio
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink
                href="/tournaments"
                className="hover:text-sivarbet-primary"
              >
                Torneos
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-sivarbet-primary">
                {cmsTournament?.title}
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <div className="relative px-8 flex flex-col items-center h-full mt-4">
          <div className="flex flex-col items-center">
            <h1 className="text-4xl max-md:text-2xl font-bold text-white mb-4">
              {tournament?.name || 'Nombre del Torneo'}
            </h1>
            <div className="space-y-2 flex flex-col items-center">
              <p className="text-xl max-md:text-base text-white/80">
                Bolsa de premios
              </p>
              <PoolPrize amount={cmsTournament?.isNetwork ? cmsTournament?.prizePool : poolPrize} />
            </div>
          </div>

          <div className="space-y-1 mb-5">
            <p className="text-xl max-md:text-base text-white/80">
              {status === 'Próximamente' ? 'El torneo comienza en:' : status === 'En curso' ? 'El torneo termina en:' : status}
            </p>
            {status !== 'Completado' && (
              <div className="flex gap-2">
                {Object.entries(timeLeft).map(([unit, value]) => {
                  const formattedUnit = formatUnits(unit.toLowerCase());
                  return (
                    <div
                      key={unit}
                      className="bg-white/10 backdrop-blur-sm rounded-lg p-2 w-24 max-md:w-20 text-center"
                    >
                      <div className="text-2xl max-md:text-lg font-bold bg-linear-to-r from-powerbet-accent to-[#ff1a9b] bg-clip-text text-transparent">
                        {value}
                      </div>
                      <div className="text-sm max-md:text-xs text-white/60 uppercase">
                        {formattedUnit}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesktopHeader;
